/**
 * Hero (jQuery)
 * - Background parallax (image bg only)
 * - Background lottie init (uses <lottie-player> if available, otherwise falls back safely)
 * - Auto-contrast (adds/removes .is-dark on the hero)
 *
 * Markup expected (from your hero.php):
 *  - .block-hero (or .block-module-hero)
 *  - .js-hero-bg (bg image div) with:
 *      data-parallax="true|false"
 *      data-parallax-speed="0.05..0.6"
 *  - .js-hero-bg-lottie (bg lottie wrapper) with:
 *      data-lottie="url"
 *      data-autoplay="true|false"
 *      data-loop="true|false"
 *  - .hero--auto-contrast (optional) enables auto text color switching
 */

jQuery(function ($) {
  var $win = $(window);

  /* ------------------------------------------------------------
   Helpers
  ------------------------------------------------------------ */
  function clamp(n, min, max) {
    n = parseFloat(n);
    if (isNaN(n)) n = min;
    return Math.max(min, Math.min(max, n));
  }

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /* ------------------------------------------------------------
   Auto contrast:
   - If hero has bg image/lottie and .hero--auto-contrast:
     we toggle .is-dark on hero so CSS can switch text colors.
   - We use a very lightweight heuristic:
     - if overlay is present and strong -> dark
     - else if background is image -> assume needs dark text? (usually light text on image)
   - Adjust rules to your taste; this avoids expensive pixel sampling.
  ------------------------------------------------------------ */
  function applyAutoContrast($hero) {
    if (!$hero.hasClass('hero--auto-contrast')) return;

    var bgTypeClass =
      $hero.hasClass('hero--bgtype-image') ? 'image' :
      ($hero.hasClass('hero--bgtype-lottie') ? 'lottie' : 'other');

    if (bgTypeClass !== 'image' && bgTypeClass !== 'lottie') return;

    // Read CSS var --hero-bg-overlay if available (0..0.8)
    var overlay = 0;
    try {
      var cs = window.getComputedStyle($hero[0]);
      var v = cs.getPropertyValue('--hero-bg-overlay');
      overlay = parseFloat((v || '').trim());
      if (isNaN(overlay)) overlay = 0;
    } catch (e) {}

    // Heuristic:
    // - If overlay >= 0.25 => dark mode content
    // - Otherwise, if bg is image/lottie => still dark mode (most designs need light text over media)
    var shouldDarken = (overlay >= 0.25) || (bgTypeClass === 'image' || bgTypeClass === 'lottie');

    $hero.toggleClass('is-dark', !!shouldDarken);
  }

  /* ------------------------------------------------------------
   Parallax (background image)
   - Applies translateY to .js-hero-bg
   - Uses requestAnimationFrame for smoothness
  ------------------------------------------------------------ */
  function initParallax($hero) {
    var $bg = $hero.find('.js-hero-bg[data-parallax="true"]').first();
    if (!$bg.length) return;

    // Disable on reduced motion or small screens if you want:
    if (prefersReducedMotion()) return;

    var speed = clamp($bg.attr('data-parallax-speed') || $hero.css('--hero-bg-parallax'), 0.05, 0.6);
    var ticking = false;

    function update() {
      ticking = false;

      var heroRect = $hero[0].getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;

      // Only animate when near viewport
      if (heroRect.bottom < -100 || heroRect.top > vh + 100) return;

      // Progress: -1..1-ish around viewport
      var center = heroRect.top + heroRect.height / 2;
      var norm = (center - (vh / 2)) / (vh / 2);
      norm = clamp(norm, -1.2, 1.2);

      // Translate amount proportional to hero height
      var maxShift = Math.min(120, heroRect.height * 0.12); // cap shift
      var y = -norm * maxShift * speed;

      $bg.css('transform', 'translate3d(0,' + y.toFixed(2) + 'px,0)');
    }

    function requestTick() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(update);
      }
    }

    // Bind
    $win.on('scroll.heroParallax resize.heroParallax', requestTick);

    // Initial
    requestTick();
  }

  /* ------------------------------------------------------------
   Lottie background
   - Tries to use <lottie-player> if available
   - If your project has a different lottie component API,
     swap the implementation inside createLottiePlayer().
  ------------------------------------------------------------ */
  function initBgLottie($hero) {
    var $wrap = $hero.find('.js-hero-bg-lottie').first();
    if (!$wrap.length) return;

    var src = $wrap.data('lottie');
    if (!src) return;

    var autoplay = String($wrap.data('autoplay')) === 'true';
    var loop = String($wrap.data('loop')) === 'true';

    // Avoid duplicate init
    if ($wrap.data('lottie-init')) return;
    $wrap.data('lottie-init', true);

    function createLottiePlayer() {
      // If lottie-player web component exists
      if (window.customElements && window.customElements.get('lottie-player')) {
        var el = document.createElement('lottie-player');
        el.setAttribute('src', src);
        el.setAttribute('background', 'transparent');
        el.setAttribute('speed', '1');
        el.style.width = '100%';
        el.style.height = '100%';
        el.style.display = 'block';

        if (loop) el.setAttribute('loop', '');
        if (autoplay) el.setAttribute('autoplay', '');

        // Improve perf
        el.setAttribute('renderer', 'svg');

        return el;
      }

      // Fallback: just show nothing (safe)
      return null;
    }

    var player = createLottiePlayer();
    if (player) {
      $wrap.empty().append(player);
    }
  }

  /* ------------------------------------------------------------
   Init all heroes
  ------------------------------------------------------------ */
  $('.block-hero, .block-module-hero').each(function () {
    var $hero = $(this);

    applyAutoContrast($hero);
    initParallax($hero);
    initBgLottie($hero);

    // Re-apply contrast on resize (in case overlay changes via breakpoints)
    $win.on('resize.heroAutoContrast', function () {
      applyAutoContrast($hero);
    });
  });
});
